<template>
    <a-drawer
        :title="dataInfo.name"
        :visible="visible"
        :width="width"
        placement="right"
        @close="close"
    >
        <div class="title strong">{{ $t('store.goods_information') }}</div>
        <div class="goods-info-box flex x-left y-top mt20" >
<!--            <div class="i-left">
                <div class="logo">
                    <img :src="dataInfo.prod_img | urlFilter(360)" alt="">
                </div>

            </div>-->
            <div class="i-right">
                <a-row>
                    <a-col :xs="24" :sm="12">
                        <div class="value"><!--门票名称-->{{ $t('store.goods_name') }}：{{ dataInfo.name }}</div>
                    </a-col>
                    <a-col :xs="24" :sm="12" v-if="dataInfo.type_name">
                        <div class="value"><!--门票类型-->{{ $t('store.goods_type') }}：{{ dataInfo.type_name }}</div>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                        <div class="value"><!--状态-->{{ $t('store.status') }}：
                            <!--dataInfo.status == 1 ? '上架' : '下架'-->
                            <a-tag color="green" v-if="dataInfo.status == 1"><!--上架-->{{ $t('store.put_away') }}</a-tag>
                            <a-tag color="red" v-if="dataInfo.status == 0"><!--下架-->{{ $t('store.sold_out') }}</a-tag>
                        </div>
                    </a-col>
                    <a-col :xs="24" :sm="12" style="margin-top: 2px">
                        <div class="value"><!--创建人-->{{ $t('store.creator') }}：{{ dataInfo.real_name }}</div>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                        <div class="value"><!--创建时间-->{{ $t('store.creation_time') }}：{{ dataInfo.create_time }}</div>
                    </a-col>
                    <a-col span="24">
                        <div class="value"><!--销售时段-->{{ $t('store.sales_period') }}：{{dataInfo.start_time}} ~ {{dataInfo.end_time}}</div>
                    </a-col>
                    <a-col :xs="24" :sm="8">
                        <div class="value"><!--基础价格-->{{ $t('store.basic_price') }}：<span class="error-color">￥{{ dataInfo.price }}</span></div>
                    </a-col>
                    <a-col :xs="24" :sm="8">
                        <div class="value"><!--剩余库存-->{{ $t('store.remaining_inventory') }}：{{ dataInfo.is_limit == 0 ? '无限制' : dataInfo.inventory + ' 件' }}</span></div>
                    </a-col>
                    <a-col :xs="24" :sm="8">
                        <div class="value">{{ $t('store.per_capita_limit') }}：{{ dataInfo.limit_num == 0 ? '不限购' : dataInfo.limit_num}}</div>
                    </a-col>
                    <a-col span="24" v-if="dataInfo.introduction">
                        <div class="value bold"><!--门票简介-->{{ $t('store.goods_brief') }}：</div>
                        <div class="value" v-html="dataInfo.introduction"></div>
                    </a-col>
                </a-row>
            </div>
        </div>
        <template v-if="false">
            <div class="title strong mt20"><!--分配信息-->{{ $t('store.distribution_information') }}</div>
            <a-table :rowKey="(record) => record.id" :pagination="false" :columns="columns" :data-source="popupData.forum_list" class="mt10" :loading="loading">

                <!--        序号        -->
                <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

                <span slot="customAction" v-if="popupData.is_limit == 1">
                <a-popover title="" :content="$t('store.distribution_total_not_greater_than_inventory')" trigger="hover">
                  <a-icon type="exclamation-circle" style="color: #56AAFE" />
                </a-popover> <!--分配量--> {{ $t('store.distribution_volume') }}
            </span>

                <!--        分配量        -->
                <span slot="action" slot-scope="text, record" v-if="popupData.is_limit == 1">
                <a-input-number :precision="0" :min="0" disabled size="small" v-model="record.assignable" /> <!--件--> {{$t('store.piece')}}
            </span>

                <!--  是否可售   -->
                <span slot="isSaleAction" slot-scope="text, record">
                <a-switch :checked-children="$t('layout.yes')" :un-checked-children="$t('layout.no')" disabled v-model="record.isSale" />
            </span>

            </a-table>
        </template>
    </a-drawer>
</template>

<script>
    export default {
        name: "GoodsInfo",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            width: {
                type: Number,
                default: 800
            },
            dataInfo: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                columns : [
                    {
                        // title: '序号',
                        title: this.$t('layout.serial_number'),
                        align: 'center',
                        scopedSlots: { customRender: 'index' },
                    },
                    {
                        // title: '分论坛名称',
                        title: this.$t('store.sub_forum_name'),
                        dataIndex: 'name',
                        align: 'center',
                    },
                    {
                        // title :'论坛状态',
                        title : this.$t('store.forum_status'),
                        dataIndex: 'status',
                        scopedSlots: { customRender: 'status' },
                        align: 'center'
                    },
                    {
                        // title: '截止日期',
                        title: this.$t('store.deadline'),
                        dataIndex: 'end_time',
                        align: 'center'
                    },
                    {
                        title : '是否可售',
                        dataIndex : 'isSale',
                        scopedSlots: { customRender: 'isSaleAction' },
                    },
                    // {
                    //     scopedSlots: { customRender: 'action' },
                    //     slots: { title: 'customAction' },
                    //     align: 'center'
                    // }
                ],
                popupData : {},
                loading : false,
            }
        },
        created() {
            this.$watch('dataInfo', (val) => {
                if(Object.keys(val).length){
                    this.confirmLoading = true;
                    this.getData();
                }
            })
        },
        methods: {
            close() {
                this.$emit('close')
            },
            getData(){
                let data = {
                    goods_id : this.dataInfo.id
                };
                this.$request.get({ url : 'allocateGoods', data }).then(res => {
                    res.data.forum_list.forEach(item => {
                        item.isSale = item.assignable_status == 1; // 0否、1是  是否可售
                    });
                    if(res.code === 200){
                        this.confirmLoading = false;
                        this.popupData = res.data;
                    }
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .goods-info-box{
        .i-left{
            width: 200px;
            flex-shrink: 0;
            .logo{
                height: 200px;
                width: 100%;
                border: 1px solid #e8e8e8;
                border-radius: 4px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #e8e8e8;
                border-radius: 4px;
                padding: 6px;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center top;
                }
            }
            .price{
                font-size: 14px;
                color: #333;
                margin-top: 20px;
            }
            .stock,.limit{
                font-size: 14px;
                color: #666;
                margin-top: 3px;
            }
        }
        .i-right{
            flex: 1;
            padding-left: 20px;
            .value{
                font-size: 14px;
                color: #666;
                margin-bottom: 10px;
            }
        }
    }
</style>